module.exports = __webpack_public_path__ + "static/img/08065C_R_2_3_20180418_fit.ea51fff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/08065C_R_2_3_20180418_fit.png
// module id = RKAn
// module chunks = 0